// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IForgotPasswordRequestDto
 */
export interface IForgotPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IForgotPasswordRequestDto
     */
    username: string;
}

/**
 * Check if a given object implements the IForgotPasswordRequestDto interface.
 */
export function instanceOfIForgotPasswordRequestDto(value: object): value is IForgotPasswordRequestDto {
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function IForgotPasswordRequestDtoFromJSON(json: any): IForgotPasswordRequestDto {
    return IForgotPasswordRequestDtoFromJSONTyped(json, false);
}

export function IForgotPasswordRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IForgotPasswordRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function IForgotPasswordRequestDtoToJSON(json: any): IForgotPasswordRequestDto {
    return IForgotPasswordRequestDtoToJSONTyped(json, false);
}

export function IForgotPasswordRequestDtoToJSONTyped(value?: IForgotPasswordRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
    };
}

